(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var cartForm = document.getElementById('cart-form');
    var modal = document.getElementById('order-modal');
    var modalForm = document.getElementById('order-modal-form');
    if (!cartForm) return;

    // Quantity buttons
    cartForm.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('input');
        if (this.dataset.action === 'decrease') {
          if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
        } else {
          input.value = parseInt(input.value) + 1;
        }
        cartForm.submit();
      });
    });

    // Open order modal on checkout click
    document.querySelectorAll('[data-open-order-modal]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (modal) modal.showModal();
      });
    });

    // Close order modal
    if (modal) {
      modal.querySelectorAll('[data-close-order-modal]').forEach(function(el) {
        el.addEventListener('click', function() {
          modal.close();
        });
      });
    }

    // Validate and submit order modal form
    if (modalForm) {
      modalForm.addEventListener('submit', function(e) {
        var submitter = e.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        var serviceChecked = modalForm.querySelector('[data-service-type] input[type="radio"]:checked');
        var isPickup = !serviceChecked || serviceChecked.getAttribute('data-service') === 'pickup';
        var fields = [
          { el: serviceChecked, parent: modalForm.querySelector('[data-service-type]'), type: 'exists' },
          { el: modalForm.querySelector('[name="attributes[Pick up date]"]'), type: 'value' },
          { el: modalForm.querySelector('[name="attributes[Contact Info]"]'), type: 'value' },
          { el: modalForm.querySelector('.order-form__checkbox input[type="checkbox"]'), type: 'checked' }
        ];
        if (isPickup) {
          fields.splice(2, 0, { el: modalForm.querySelector('[name="attributes[Pick up Window]"]:checked'), parent: modalForm.querySelector('[data-pickup-window]'), type: 'exists' });
          fields.splice(3, 0, { el: modalForm.querySelector('[name="attributes[Pick up/Delivery Time]"]'), type: 'value' });
        } else {
          fields.splice(2, 0, { el: modalForm.querySelector('[name="attributes[Delivery Window]"]:checked'), parent: modalForm.querySelector('[data-delivery-window]'), type: 'exists' });
        }

        var missing = [];
        fields.forEach(function(f) {
          if (f.type === 'value' && f.el && !f.el.value) missing.push(f.el);
          if (f.type === 'exists' && !f.el) missing.push(f.parent);
          if (f.type === 'checked' && f.el && !f.el.checked) missing.push(f.el);
        });

        if (missing.length > 0) {
          e.preventDefault();
          var first = missing[0];
          var firstField = first.closest && first.closest('.order-form__field');
          (firstField || first).scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (first.focus) first.focus();
          missing.forEach(function(el) {
            var field = el && el.closest && el.closest('.order-form__field');
            var target = field || el;
            if (target && target.classList) {
              target.classList.add('order-form__field--error');
              setTimeout(function() {
                target.classList.remove('order-form__field--error');
              }, 3000);
            }
          });
          return;
        }

        // Save cart attributes then redirect to checkout
        e.preventDefault();
        submitter.disabled = true;
        submitter.textContent = '...';

        var formData = new FormData(modalForm);
        var attributes = {};
        formData.forEach(function(value, key) {
          var match = key.match(/^attributes\[(.+)\]$/);
          if (match) attributes[match[1]] = value;
        });

        // Also save the cart note
        var noteEl = document.getElementById('cart-note');
        var updateBody = { attributes: attributes };
        if (noteEl) updateBody.note = noteEl.value;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updateBody)
        })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function() {
          submitter.disabled = false;
          submitter.textContent = document.querySelector('[data-open-order-modal]').textContent.trim();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var searchInput = document.getElementById('collection-search');
    if (!searchInput) return;

    var cards = document.querySelectorAll('.product-card');
    var countEl = document.getElementById('collection-count');
    var totalCount = cards.length;

    searchInput.addEventListener('input', function() {
      var query = this.value.toLowerCase().trim();
      var visible = 0;

      cards.forEach(function(card) {
        var title = (card.dataset.productTitle || '').toLowerCase();
        if (!query || title.indexOf(query) !== -1) {
          card.style.display = '';
          visible++;
        } else {
          card.style.display = 'none';
        }
      });

      if (countEl) {
        countEl.textContent = visible + ' products';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-workshop"]) return;
  try {
    
  (function() {
    var variantSelect = document.getElementById('workshop-variant-id');
    var submitBtn = document.getElementById('workshop-submit');
    var priceEl = document.querySelector('.workshop-product__price');
    var comparePriceEl = document.querySelector('.workshop-product__compare-price');
    var mainImg = document.getElementById('workshop-main-img');

    if (!variantSelect) return;

    function getSelectedOptions() {
      var options = [];
      document.querySelectorAll('.workshop-product__option').forEach(function(wrapper) {
        var btnGroup = wrapper.querySelector('.workshop-product__option-btns');
        if (btnGroup) {
          var active = btnGroup.querySelector('.workshop-product__option-btn--active');
          if (active) options.push(active.dataset.value);
        } else {
          var sel = wrapper.querySelector('.workshop-product__select');
          if (sel) options.push(sel.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variantSelect.options.length; i++) {
        var opt = variantSelect.options[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          var optionValue = opt.dataset['option' + (j + 1)];
          if (!optionValue || optionValue !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return opt;
      }
      return null;
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variantOpt = findVariant(options);
      if (!variantOpt) return;

      variantSelect.value = variantOpt.value;

      if (priceEl) priceEl.textContent = variantOpt.dataset.price;
      var compareRaw = parseInt(variantOpt.dataset.comparePriceRaw);
      var priceRaw = parseInt(variantOpt.dataset.priceRaw);
      if (comparePriceEl) {
        if (compareRaw > priceRaw) {
          priceEl.classList.add('workshop-product__price--sale');
          comparePriceEl.textContent = variantOpt.dataset.comparePrice;
          comparePriceEl.style.display = '';
        } else {
          priceEl.classList.remove('workshop-product__price--sale');
          comparePriceEl.style.display = 'none';
        }
      }

      var available = variantOpt.dataset.available === 'true';
      submitBtn.disabled = !available;
      submitBtn.textContent = available ? submitBtn.dataset.addText : submitBtn.dataset.soldText;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantOpt.value);
      window.history.replaceState({}, '', url.toString());
    }

    // Event delegation for option buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.workshop-product__option-btn');
      if (!btn) return;
      var group = btn.closest('.workshop-product__option-btns');
      if (!group) return;
      group.querySelectorAll('.workshop-product__option-btn').forEach(function(b) {
        b.classList.remove('workshop-product__option-btn--active');
      });
      btn.classList.add('workshop-product__option-btn--active');
      updateVariant();
    });

    // Event delegation for option selects
    document.addEventListener('change', function(e) {
      if (e.target.matches('.workshop-product__select')) {
        updateVariant();
      }
    });

    // Thumbnail clicks
    var activeThumb = document.querySelector('.workshop-product__thumb--active');
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.workshop-product__thumb');
      if (!thumb) return;
      if (thumb === activeThumb) return;
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
      mainImg.sizes = '(max-width: 768px) 100vw, 50vw';
      if (activeThumb) activeThumb.classList.remove('workshop-product__thumb--active');
      thumb.classList.add('workshop-product__thumb--active');
      activeThumb = thumb;
    });

    // Form validation + skip cart, go straight to checkout
    document.getElementById('workshop-form').addEventListener('submit', function(e) {
      e.preventDefault();
      var form = this;
      var required = form.querySelectorAll('[required]');
      var missing = [];
      required.forEach(function(el) {
        if (!el.value.trim()) missing.push(el);
      });
      if (missing.length > 0) {
        missing[0].focus();
        missing.forEach(function(el) {
          el.classList.add('workshop-form__input--error');
          setTimeout(function() { el.classList.remove('workshop-form__input--error'); }, 3000);
        });
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      var formData = new FormData(form);
      var properties = {};
      formData.forEach(function(value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });

      var variantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity')) || 1;

      // Clear cart, add just this workshop item, then go to checkout
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: quantity, properties: properties })
        });
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.addText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var variantSelect = document.getElementById('product-variant-id');
    var addBtn = document.getElementById('product-add-btn');
    var priceEl = document.getElementById('product-price');
    var comparePriceEl = document.getElementById('product-compare-price');
    var saleBadge = document.getElementById('product-sale-badge');
    var mainImg = document.getElementById('product-main-img');

    if (!variantSelect) return;

    function getSelectedOptions() {
      var options = [];
      document.querySelectorAll('.product-page__option').forEach(function(wrapper) {
        var btnGroup = wrapper.querySelector('.product-page__option-btns');
        if (btnGroup) {
          var active = btnGroup.querySelector('.product-page__option-btn--active');
          if (active) options.push(active.dataset.value);
        } else {
          var sel = wrapper.querySelector('.product-page__option-select');
          if (sel) options.push(sel.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variantSelect.options.length; i++) {
        var opt = variantSelect.options[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          var optionValue = opt.dataset['option' + (j + 1)];
          if (!optionValue || optionValue !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return opt;
      }
      return null;
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variantOpt = findVariant(options);
      if (!variantOpt) return;

      variantSelect.value = variantOpt.value;

      var startingFrom = document.querySelector('.product-page__starting-from');
      if (startingFrom) startingFrom.style.display = 'none';

      priceEl.textContent = variantOpt.dataset.price;
      var compareRaw = parseInt(variantOpt.dataset.comparePriceRaw);
      var priceRaw = parseInt(variantOpt.dataset.priceRaw);
      if (compareRaw > priceRaw) {
        priceEl.classList.add('product-page__price--sale');
        comparePriceEl.textContent = variantOpt.dataset.comparePrice;
        comparePriceEl.style.display = '';
        saleBadge.style.display = '';
      } else {
        priceEl.classList.remove('product-page__price--sale');
        comparePriceEl.style.display = 'none';
        saleBadge.style.display = 'none';
      }

      var available = variantOpt.dataset.available === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.dataset.addText || 'Add to Cart' : addBtn.dataset.soldText || 'Sold Out';
      }

      var imageId = variantOpt.dataset.imageId;
      if (imageId && mainImg) {
        document.querySelectorAll('.product-page__thumb').forEach(function(thumb) {
          if (thumb.dataset.imageId === imageId) {
            switchToThumb(thumb);
          }
        });
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantOpt.value);
      window.history.replaceState({}, '', url.toString());
    }

    // Event delegation for option buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-page__option-btn');
      if (!btn) return;
      var group = btn.closest('.product-page__option-btns');
      if (!group) return;
      group.querySelectorAll('.product-page__option-btn').forEach(function(b) {
        b.classList.remove('product-page__option-btn--active');
      });
      btn.classList.add('product-page__option-btn--active');
      updateVariant();
    });

    // Event delegation for option selects
    document.addEventListener('change', function(e) {
      if (e.target.matches('.product-page__option-select')) {
        updateVariant();
      }
    });

    // Thumbnail clicks
    var activeThumb = document.querySelector('.product-page__thumb--active');
    function switchToThumb(thumb) {
      if (thumb === activeThumb) return;
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
      mainImg.sizes = '(max-width: 768px) 100vw, 50vw';
      if (activeThumb) activeThumb.classList.remove('product-page__thumb--active');
      thumb.classList.add('product-page__thumb--active');
      activeThumb = thumb;
    }
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.product-page__thumb');
      if (thumb) switchToThumb(thumb);
    });

    // Buy Now modal
    var buyNowBtn = document.getElementById('product-buy-now');
    var modal = document.getElementById('buy-now-modal');
    var buyNowForm = document.getElementById('buy-now-form');

    if (buyNowBtn && modal) {
      buyNowBtn.addEventListener('click', function() {
        // Sync variant and quantity to modal hidden fields
        var vid = document.getElementById('buy-now-variant-id');
        var qty = document.getElementById('buy-now-qty');
        if (vid) vid.value = variantSelect.value;
        var qtyInput = document.getElementById('product-qty');
        if (qty && qtyInput) qty.value = qtyInput.value;

        // Update modal variant info
        var selectedOpt = variantSelect.options[variantSelect.selectedIndex];
        var variantTitle = selectedOpt.text.trim();
        var buyNowVariant = document.getElementById('buy-now-variant');
        if (buyNowVariant) {
          buyNowVariant.textContent = variantTitle === 'Default Title' ? '' : variantTitle;
        }
        var buyNowPrice = document.getElementById('buy-now-price');
        if (buyNowPrice) buyNowPrice.textContent = selectedOpt.dataset.price;

        modal.showModal();
      });

      // Close modal
      modal.querySelectorAll('[data-close-modal]').forEach(function(el) {
        el.addEventListener('click', function() {
          modal.close();
        });
      });

      // On submit: add to cart first, then let the form submit to checkout
      if (buyNowForm) {
        buyNowForm.addEventListener('submit', function(e) {
          var submitter = e.submitter;
          if (!submitter || submitter.name !== 'checkout') return;

          // Validate order form fields inside modal
          var serviceChecked = buyNowForm.querySelector('[data-service-type] input[type="radio"]:checked');
          var isPickup = !serviceChecked || serviceChecked.getAttribute('data-service') === 'pickup';
          var fields = [
            { el: serviceChecked, parent: buyNowForm.querySelector('[data-service-type]'), type: 'exists' },
            { el: buyNowForm.querySelector('[name="attributes[Pick up date]"]'), type: 'value' },
            { el: buyNowForm.querySelector('[name="attributes[Contact Info]"]'), type: 'value' },
            { el: buyNowForm.querySelector('.order-form__checkbox input[type="checkbox"]'), type: 'checked' }
          ];
          if (isPickup) {
            fields.splice(2, 0, { el: buyNowForm.querySelector('[name="attributes[Pick up Window]"]:checked'), parent: buyNowForm.querySelector('[data-pickup-window]'), type: 'exists' });
            fields.splice(3, 0, { el: buyNowForm.querySelector('[name="attributes[Pick up/Delivery Time]"]'), type: 'value' });
          } else {
            fields.splice(2, 0, { el: buyNowForm.querySelector('[name="attributes[Delivery Window]"]:checked'), parent: buyNowForm.querySelector('[data-delivery-window]'), type: 'exists' });
          }

          var missing = [];
          fields.forEach(function(f) {
            if (f.type === 'value' && f.el && !f.el.value) missing.push(f.el);
            if (f.type === 'exists' && !f.el) missing.push(f.parent);
            if (f.type === 'checked' && f.el && !f.el.checked) missing.push(f.el);
          });

          if (missing.length > 0) {
            e.preventDefault();
            var first = missing[0];
            var firstField = first.closest && first.closest('.order-form__field');
            (firstField || first).scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (first.focus) first.focus();
            missing.forEach(function(el) {
              var field = el && el.closest && el.closest('.order-form__field');
              var target = field || el;
              if (target && target.classList) {
                target.classList.add('order-form__field--error');
                setTimeout(function() { target.classList.remove('order-form__field--error'); }, 3000);
              }
            });
            return;
          }

          // Add item to cart, update attributes, then redirect to checkout
          e.preventDefault();
          submitter.disabled = true;
          submitter.textContent = '...';

          var variantId = document.getElementById('buy-now-variant-id').value;
          var quantity = document.getElementById('buy-now-qty').value;

          // Collect cart attributes from form
          var formData = new FormData(buyNowForm);
          var attributes = {};
          formData.forEach(function(value, key) {
            var match = key.match(/^attributes\[(.+)\]$/);
            if (match) attributes[match[1]] = value;
          });

          // Add to cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
          })
          .then(function() {
            // Update cart attributes
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            });
          })
          .then(function() {
            window.location.href = '/checkout';
          })
          .catch(function() {
            submitter.disabled = false;
            submitter.textContent = 'Checkout';
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var input = document.getElementById('search-input');
    var clearBtn = document.getElementById('search-clear');
    var predictiveWrap = document.getElementById('predictive-search');
    var predictiveResults = document.getElementById('predictive-results');
    var predictiveLoading = document.getElementById('predictive-loading');
    var debounceTimer = null;
    var abortController = null;

    if (!input) return;

    function toggleClear() {
      clearBtn.style.display = input.value.length > 0 ? '' : 'none';
    }

    clearBtn.addEventListener('click', function() {
      input.value = '';
      input.focus();
      toggleClear();
      hidePredictive();
    });

    function hidePredictive() {
      predictiveWrap.style.display = 'none';
      predictiveResults.innerHTML = '';
    }

    function showLoading() {
      predictiveWrap.style.display = '';
      predictiveLoading.style.display = '';
      predictiveResults.innerHTML = '';
    }

    function fetchPredictive(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      showLoading();

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6', {
        signal: abortController.signal
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        predictiveLoading.style.display = 'none';
        var resources = data.resources && data.resources.results;
        if (!resources) { hidePredictive(); return; }

        var html = '';
        var groups = ['products', 'articles', 'pages'];
        var hasResults = false;

        groups.forEach(function(group) {
          var items = resources[group];
          if (!items || items.length === 0) return;
          hasResults = true;

          items.forEach(function(item) {
            var imgHtml = '';
            if (item.image || item.featured_image) {
              var imgSrc = (item.featured_image && item.featured_image.url) || item.image;
              imgHtml = '<img src="' + imgSrc + '&width=120&height=120&crop=center" alt="" loading="lazy">';
            } else {
              imgHtml = '<span class="predictive-search__no-img"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></span>';
            }

            var priceHtml = '';
            if (item.price) {
              priceHtml = '<span class="predictive-search__price">' + item.price + '</span>';
            }

            html += '<a href="' + item.url + '" class="predictive-search__item">'
              + '<div class="predictive-search__item-img">' + imgHtml + '</div>'
              + '<div class="predictive-search__item-info">'
              + '<span class="predictive-search__item-title">' + item.title + '</span>'
              + priceHtml
              + '</div>'
              + '</a>';
          });
        });

        if (!hasResults) {
          hidePredictive();
          return;
        }

        html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">'
          + 'View all results <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
          + '</a>';

        predictiveResults.innerHTML = html;
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') hidePredictive();
      });
    }

    input.addEventListener('input', function() {
      toggleClear();
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        hidePredictive();
        return;
      }
      debounceTimer = setTimeout(function() {
        fetchPredictive(q);
      }, 300);
    });

    document.addEventListener('click', function(e) {
      if (!predictiveWrap.contains(e.target) && e.target !== input) {
        hidePredictive();
      }
    });

    input.addEventListener('focus', function() {
      if (input.value.trim().length >= 2 && predictiveResults.innerHTML) {
        predictiveWrap.style.display = '';
      }
    });

    toggleClear();
  })();

  } catch(e) { console.error(e); }
})();
})();
